<template>
        <div class="flexbox" >
            <a :href="newsletterUrl" target="_blank">
                <base-button size="large" type="success">
                    Bleiben Sie auf dem Laufenden
                </base-button>
            </a>
            <el-select
                v-model="chosenWidgets"
                multiple
                collapse-tags
                default-first-option
                placeholder="Widgets"
                no-match-text="Keine Widgets gefunden"
                class="primary widgetSelect">
                <el-option-group
                    v-for="group in groups"
                    :key="group.id">
                    <slot>
                        <span class="mr-2 widgetSelectTitle float-left" :class="group.iconClass"></span>
                        <li class="el-select-group__title">{{ group.label }}</li>
                    </slot>
                    <el-option
                        v-for="item in availableWidgets.filter(item => (item.groupId === group.id))"
                        :key="item.i"
                        :label="item.selectName"
                        :value="item.i">
                    </el-option>
                </el-option-group>
            </el-select>
        </div>
    <div class="content">
        <grid-layout
            v-model:layout="activeWidgets"
            :margin="[30, 30]"
            :col-num="colNumber"
            :row-height="rowHeight"
            :is-draggable="editable"
            :is-resizable="false"
            :vertical-compact="true"
            :use-css-transforms="true"
            :responsive="true"
            @layout-updated="widgetsUpdated">
            <grid-item
                @mouseenter="item.isResizable = true"
                @mouseleave="item.isResizable = false"
                v-for="item in activeWidgets"
                :static="item.static"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                :maxH="item.maxH"
                :minH="item.minH"
                :minW="item.minW"
                :maxW="item.maxW"
                :key="item.i"
                :isResizable="item.isResizable">
                <component :is="item.widgetName" :showHeader="item.header"></component>
                <span v-if="item.isResizable" class="remove" @click="removeItem(item.i)">x
                </span>
            </grid-item>
        </grid-layout>
    </div>
</template>

<script>
import {ref, watch, computed, onBeforeMount} from "vue";
import {useStore} from 'vuex';
import IncidentsOpen from "@/views/Widgets/IncidentsOpen";
import IncidentsClosed from "@/views/Widgets/IncidentsClosed";
import IncidentsToday from "@/views/Widgets/IncidentsToday";
import IncidentChartCategory from "@/views/Widgets/IncidentChartCategory";
import IncidentChartMonth from "@/views/Widgets/IncidentChartMonth";
import ContractVolume from "@/views/Widgets/ContractVolume";
import ContractPreVolume from "@/views/Widgets/ContractPreVolume";
import ServicesMonth from "@/views/Widgets/ServicesMonth";
import ServicesMonthFree from "@/views/Widgets/ServicesMonthFree";
import ServicesYear from "@/views/Widgets/ServicesYear";
import ServicesYearFree from "@/views/Widgets/ServicesYearFree";
import ServicesYearCourtesyTotal from "@/views/Widgets/ServicesYearCourtesyTotal";
import ServicesMonthCourtesyTotal from "@/views/Widgets/ServicesMonthCourtesyTotal";
import InvoiceOpenNumber from "@/views/Widgets/InvoiceOpenNumber";
import InvoiceOpenAmount from "@/views/Widgets/InvoiceOpenAmount";
import InvoiceSubscription from "@/views/Widgets/InvoiceSubscription";
import {
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption,
    ElOptionGroup,
} from "element-plus";
import BaseButton from "../../components/BaseButton.vue";

export default {
    components: {
        BaseButton,
        IncidentsOpen,
        IncidentsClosed,
        IncidentsToday,
        IncidentChartCategory,
        IncidentChartMonth,
        ContractVolume,
        ContractPreVolume,
        ServicesMonth,
        ServicesMonthFree,
        ServicesYear,
        ServicesYearFree,
        ServicesYearCourtesyTotal,
        ServicesMonthCourtesyTotal,
        InvoiceOpenNumber,
        InvoiceOpenAmount,
        InvoiceSubscription,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
        [ElOptionGroup.name]: ElOptionGroup,
    },
    setup() {
        const store = useStore();
        const currentUser = computed(() => store.state.auth.user);
        const widgetsUser = computed({
            get() {
                return store.state.dashboard.widgets;
            },
            set(value) {
                store.commit('dashboard/setWidgets', value);
            }
        });
        const newsletterUrl = ref('https://www.talus.ch/de/newsletter/index.php')
        const editable = ref(true);

        /*function toggleEditable() {
            editable.value = !editable.value;
        }*/

        const groups = ref([]);

        const colNumber = ref(12);
        const rowHeight = ref(12);
        const chosenWidgets = ref([]);
        const activeWidgets = ref([]);
        const availableWidgets = ref([]);

        //add topdesk group and widgets
        if (currentUser.value.roles.indexOf('abacus_user') !== -1) {
            groups.value.push({id: 1, label: "Servicedesk", iconClass: 'fad fa-tasks text-success'});
            availableWidgets.value.push(
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "0",
                    groupId: 1,
                    selectName: "Offene Fälle",
                    widgetName: "IncidentsOpen",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "1",
                    groupId: 1,
                    selectName: "Geschlossene Fälle",
                    widgetName: "IncidentsClosed",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "2",
                    groupId: 1,
                    selectName: "Heute fällig",
                    widgetName: "IncidentsToday",
                    static: false,
                    header: true
                },
                {
                    w: 6,
                    h: 16,
                    minW: 6,
                    maxH: 16,
                    minH: 16,
                    i: "3",
                    groupId: 1,
                    selectName: "Kategorienverteilung",
                    widgetName: "IncidentChartCategory",
                    static: false,
                    header: true
                },
                {
                    w: 6,
                    h: 16,
                    minW: 6,
                    maxH: 16,
                    minH: 16,
                    i: "4",
                    groupId: 1,
                    selectName: "Monatsverteilung",
                    widgetName: "IncidentChartMonth",
                    static: false,
                    header: true
                },
            )
        }

        //add crm group and widgets
        if (currentUser.value.roles.indexOf('abacus_user') !== -1) {
            groups.value.push({id: 2, label: "CRM", iconClass: 'fad fa-balance-scale text-danger'});
            availableWidgets.value.push(
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "5",
                    groupId: 2,
                    selectName: "Vertragsvolumen",
                    widgetName: "ContractVolume",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "6",
                    groupId: 2,
                    selectName: "Vertragsvolumen (Vorjahr)",
                    widgetName: "ContractPreVolume",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "7",
                    groupId: 2,
                    selectName: "Leistungsbetrag (Monat)",
                    widgetName: "ServicesMonth",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "8",
                    groupId: 2,
                    selectName: "Leistungsbetrag (Jahr)",
                    widgetName: "ServicesYear",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "9",
                    groupId: 2,
                    selectName: "Kulanz (Monat)",
                    widgetName: "ServicesMonthFree",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "10",
                    groupId: 2,
                    selectName: "Kulanz (Jahr)",
                    widgetName: "ServicesYearFree",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "11",
                    groupId: 2,
                    selectName: "Kulanz (Monat) Betrag",
                    widgetName: "ServicesMonthCourtesyTotal",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "12",
                    groupId: 2,
                    selectName: "Kulanz (Jahr) Betrag",
                    widgetName: "ServicesYearCourtesyTotal",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "13",
                    groupId: 2,
                    selectName: "Offene Rechnungen",
                    widgetName: "InvoiceOpenNumber",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "14",
                    groupId: 2,
                    selectName: "Offener Rechnungsbetrag",
                    widgetName: "InvoiceOpenAmount",
                    static: false,
                    header: true
                },
                {
                    w: 3,
                    h: 5,
                    minW: 3,
                    maxH: 5,
                    minH: 5,
                    i: "15",
                    groupId: 2,
                    selectName: "Restbestand - DL Abo",
                    widgetName: "InvoiceSubscription",
                    static: false,
                    header: true
                },

            );
        }

        //add rio group and widgets
        /*if(currentUser.value.roles.indexOf('rio_user') !== -1){
            groups.value.push({id: 3, label: "RIONet", iconClass: 'fad fa-server text-info'});
        }*/

        function addItem(index) {
            const itemIndex = availableWidgets.value.map(item => item.i).indexOf(index);
            const item = availableWidgets.value[itemIndex];
            const length = activeWidgets.value.reduce((partialSum, a) => partialSum + a.w, 0);
            item.x = length % (colNumber.value || 12);
            if((item.x + item.w) > 12){
                item.x = 0;
            }
            item.y = (parseInt(length / (colNumber.value || 12)) * 5) + (colNumber.value || 12);
            activeWidgets.value.push(item);
            window.dispatchEvent(new Event("resize"));
            widgetsUpdated(activeWidgets.value);
        }

        function removeItem(item) {
            const index = activeWidgets.value.map(item => item.i).indexOf(item);
            activeWidgets.value.splice(index, 1);
            if (chosenWidgets.value.indexOf(item) !== -1) {
                const indexSelect = chosenWidgets.value.indexOf(item);
                chosenWidgets.value.splice(indexSelect, 1);
            }
            window.dispatchEvent(new Event("resize"));
            widgetsUpdated(activeWidgets.value);
        }

        function widgetsUpdated(dashboard) {
            widgetsUser.value = dashboard;
        }

        function getActiveWidgets() {
            widgetsUser.value.map(item => {
                chosenWidgets.value.push(item.i);
            });
            activeWidgets.value = widgetsUser.value;
        }

        function selectionChanged() {
            availableWidgets.value.map(item => {
                if (chosenWidgets.value.includes(item.i) && !activeWidgets.value.map(value => value.i).includes(item.i)) {
                    addItem(item.i);
                }
                if (!chosenWidgets.value.includes(item.i) && activeWidgets.value.map(value => value.i).includes(item.i)) {
                    removeItem(item.i);
                }
            });
        }

        onBeforeMount(() => {
            if (currentUser.value.widgets && widgetsUser.value.length === 0) {
                widgetsUser.value = currentUser.value.widgets;
            }
            getActiveWidgets();
        });

        watch(chosenWidgets, selectionChanged);

        return {
            newsletterUrl,
            groups,
            colNumber,
            rowHeight,
            activeWidgets,
            availableWidgets,
            widgetsUser,
            chosenWidgets,
            editable,
            removeItem,
            widgetsUpdated,
        };
    },
};
</script>
<style lang="scss">

.flexbox {
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.vue-grid-layout {
    margin-left: -30px;
    margin-right: -30px;
}

.layoutJSON {
    background: #ddd;
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
}

.columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
}


.content .vue-grid-item.vue-grid-placeholder {
    background: var(--primary);
}

.vue-grid-item.resizing {
    opacity: 0.9;
}

.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}

.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}

.vue-grid-item .minMax {
    font-size: 12px;
}

.vue-grid-item .add {
    cursor: pointer;
}

.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected:after {
    position: absolute;
    right: 20px;
    content: "\f00c";
    font-family: "Font Awesome 6 Duotone";
    font-size: 12px;
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.widgetSelectTitle {
    padding-left: 21px;
    font-size: 12px;
    color: var(--el-color-info);
    line-height: 30px;
}

.widgetSelect {
    min-width: 300px;
}

.remove {
    position: absolute;
    right: -4px;
    top: -13px;
    cursor: pointer;
    padding: 10px;
}

.vue-resizable {

}

.el-select-group__title {
    list-style: none !important;
}
</style>
